import React from 'react';
import { Trash } from '@saleshandy/icons';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { accessibleOnClick } from '../../../../../shared/utils/accessible-on-click';
// import Modal from '../../../../../shared/design-system/components/atoms/modal';

interface DeleteTemplateModalProps {
  show: boolean;
  onClose: () => void;
  onDelete: () => void;
  isRequestPending: boolean;
  templateName?: string;
}

const DeleteTemplateModal: React.FC<DeleteTemplateModalProps> = ({
  show,
  onClose,
  onDelete,
  isRequestPending,
  templateName,
}) => (
  <Modal
    show={show}
    className="ai-col-enrichment-delete-template-modal"
    onClose={onClose}
    onSubmit={onDelete}
    onHide={onClose}
    backdrop="static"
    centered
  >
    <div className="delete-template-modal-container">
      <div className="delete-template-modal-header">
        <Trash width={16} height={16} className="red-txt-12" />
        <div className="delete-title">Delete Template</div>
      </div>
      <div className="delete-template-modal-body">
        <span className="delete-template-modal-text">
          Are you sure you want to delete{' '}
          <span className="template-name">
            {templateName ? `"${templateName}"` : 'this template'}{' '}
          </span>
          template permanently ?
        </span>
      </div>
    </div>
    <div className="divider-line" />
    <div className="delete-template-modal-footer">
      <div className="cancel-button" {...accessibleOnClick(onClose)}>
        Cancel
      </div>
      <div className="delete-btn">
        <Button
          {...accessibleOnClick(onDelete)}
          disabled={isRequestPending}
          className={`${isRequestPending ? 'disabled' : ''}`}
        >
          {isRequestPending ? (
            <div className="d-flex align-items-center">
              <Spinner animation="border" className='delete-spinner' />
              <span>Delete</span>
            </div>
          ) : (
            'Delete'
          )}
        </Button>
      </div>
    </div>
  </Modal>
);

export default DeleteTemplateModal;
